import { baseResourceOptions } from './utils';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { SidekickThreadFast } from 'src/models/Sidekick/SidekickThreads';

const sidekickFastThreadsResource = createCollectionResource<SidekickThreadFast>({
  name: 'sidekickFastThreads',
  endpoint: 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows/fast',
  type: SidekickThreadFast,
  observerCreator: emptyObserverCreator,
  options: {
    ...baseResourceOptions,
  },
});

export default sidekickFastThreadsResource;
